import { Button, ClickAwayListener, Dialog, DialogTitle } from "@mui/material";
import { useState } from "react";
import { IContext, IGroupUsers, ITopic, PostTopicResponse } from "../../types";
import { topicCreator } from "../../functions/fetchers";
import { UserListPanel } from "./UserListPanel";

interface NewTopicDialogProps {
    open: boolean;
    onClose: () => void;
    context: IContext;
    onTopicCreated: (topic: ITopic) => void;
}

export function NewTopicDialog({ open, onClose,  context, onTopicCreated }: NewTopicDialogProps) {
    const [filteredName, setFilteredName] = useState("");
    const [loadingUserId, setLoadingUserId] = useState<number>(-1);
    const [error, setError] = useState("");

    const handleUserClick = async (userId: number) => {
        if (loadingUserId !== -1) return;
        setLoadingUserId(userId);
        try {
            const res: PostTopicResponse = await topicCreator(userId, { context });
            const topic = Object.values(res.topics)[0];
            if (topic) {
                onTopicCreated(topic);
            }
            onClose();
        } catch (e: any) {
            setError(e?.message ?? "خطا در ایجاد گفتگو");
        } finally {
            setLoadingUserId(-1);
        }
    };

    return (
        <Dialog
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "24rem",
                        borderRadius: "1rem",
                    },
                },
            }}
            open={open}
            onClose={onClose}
        >
            <ClickAwayListener onClickAway={onClose}>
                <div className="flex flex-col p-4">
                    <DialogTitle className="px-0 pt-0 font-bold">
                        ارسال پیام به یک نفر
                    </DialogTitle>
                    <input
                        value={filteredName}
                        onChange={(e) => setFilteredName(e.target.value)}
                        type="text"
                        className="mb-3 p-2 border border-stone-200 rounded w-full"
                        placeholder="جستجوی نام..."
                    />
                    {error && (
                        <span className="mb-2 text-red-500 text-sm">{error}</span>
                    )}
                    <div className="max-h-120 overflow-y-auto">
                        <UserListPanel
                            filteredName={filteredName}
                            mode="click"
                            onUserClick={handleUserClick}
                            loadingUserId={loadingUserId}
                        />
                    </div>
                    <div className="flex justify-end mt-3 pt-2 border-stone-200 border-t">
                        <Button onClick={onClose}>انصراف</Button>
                    </div>
                </div>
            </ClickAwayListener>
        </Dialog>
    );
}
